import { useBillable } from "@/modules/work/billables/context";
import { BillableBreadcrumbs } from "@/modules/work/billables/components/header/breadcrumbs";

export const BillableHeader = () => {
  const { billable } = useBillable();
  return (
    <div className="sticky top-16 z-30 bg-background border-b">
      <div className="h-12 px-4 flex items-center justify-start gap-4">
        <BillableBreadcrumbs billable={billable} />
      </div>
    </div>
  );
};
